<template>
  <div class="container">
    <div v-if="!isPaymentDataSet" class="paywall">
      <h1 class="page-title_hidden" id="page-title-for-sr">{{ $t('paywall.processing.pageTitle') }}</h1>
      <div class="columns loader"><span class="sr-only">{{ $t('paywall.processing.loaderAnimation') }}</span>
        <section class="sidebar-column" id="payment-section-summary" aria-labelledby="section-summary-heading">
          <order-details-side :transaction="transaction"
                              :visibility="visibilityOptions"
                              :show-button="false" />
        </section>
        <section class="main-column">
          <div class="content">
            <div class="payment-processing-loader-wrapper">
              <div class="loader-text">
                <h1>{{ $t('paywall.processing.header') }}</h1>
                <p>{{ $t('paywall.processing.description') }}</p>
                <div class="info">
                  <p>
                    <strong>{{ $t('paywall.processing.info.header') }}</strong>
                    {{ $t('paywall.processing.info.description') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div v-else>
      <payment-loading/>
      <payment-psd2-data v-if="isPaymentPsd2DataSet" :payment-data="paymentData" />
      <payment-data v-else :payment-data="paymentData"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OrderDetailsSide from '@/base/components/OrderDetails/Side'
import PaymentData from '@/base/components/Payment/Data/PaymentData'
import loadingMixin from '@/base/mixins/loading.mixin'
import { ToolsClass } from '@/base/class/tools.class'
import PaymentPsd2Data from '@/base/components/Payment/Data/PaymentPsd2Data'
import PaymentLoading from '@/base/components/Payment/Loader/Loading.vue'

export default {
  name: 'PaymentProcessing',
  mixins: [loadingMixin],
  components: {
    PaymentLoading,
    PaymentPsd2Data,
    OrderDetailsSide,
    PaymentData
  },
  computed: {
    ...mapState({
      transaction: state => state.payment.paymentData.transaction,
      visibilityOptions: state => state.payment.paymentData.visibilityOptions
    })
  },
  created () {
    ToolsClass.scrollToElementTop(document.querySelector('header'))
  }
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/components/_processing-loader.scss";
</style>
